import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../../firebase/firestore";

export default function Footer() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const [contactConfig, setContactConfig] = useState({
    supportEmail: "shreejisurtiswad@gmail.com",
    supportPhone: "7977788566",
    supportWhatsApp: "8454874147",
  });

  useEffect(() => {
    const ref = doc(db, "appConfig", "platform");
    const unsubscribe = onSnapshot(ref, (snap) => {
      if (!snap.exists()) return;
      setContactConfig((prev) => ({
        ...prev,
        ...snap.data(),
      }));
    });

    return () => unsubscribe();
  }, []);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email.trim()) {
      setSubscribed(true);
      setEmail("");
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  const links = {
    company: [
      { label: "About Us", path: "/about" },
      { label: "Team", path: "/team" },
      { label: "Partner with Us", path: "/partner" },
      { label: "Careers", path: "#" }
    ],
    support: [
      { label: "Help & Support", path: "/support" },
      { label: "Track Order", path: "/orders" },
      { label: "Contact Us", path: "/support" },
      { label: "Feedback", path: "#" }
    ],
    legal: [
      { label: "Terms & Conditions", path: "/terms" },
      { label: "Privacy Policy", path: "/privacy" },
      { label: "Refund Policy", path: "/refund" },
      { label: "Cookie Policy", path: "/cookie" }
    ]
  };

  const waDigits = String(contactConfig.supportWhatsApp || "8454874147").replace(/\D/g, "").slice(-10);
  const whatsappHref = `https://wa.me/91${waDigits || "8454874147"}?text=hi`;

  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* TOP SECTION - BRAND + NEWSLETTER */}
        <div className="footer-top">
          <div className="footer-brand">
            <h2>🍜 Shreeji Surti Swad</h2>
            <p>Authentic Taste of Surat • Fresh • Homemade • Delicious</p>
            
            <div className="footer-tagline">
              <span>Bringing the flavors of Surat to your doorstep</span>
            </div>

            <div className="footer-tagline" style={{ marginTop: "0.5rem" }}>
              <span>
                Contact: {contactConfig.supportEmail} | +91 {contactConfig.supportPhone} | WhatsApp: +91 {waDigits || "8454874147"}
              </span>
            </div>

            <div className="socials">
              <a href="https://www.facebook.com" title="Facebook" className="social-btn" target="_blank" rel="noreferrer">f</a>
              <a href="https://www.instagram.com" title="Instagram" className="social-btn" target="_blank" rel="noreferrer">📸</a>
              <a href="https://x.com" title="Twitter" className="social-btn" target="_blank" rel="noreferrer">𝕏</a>
              <a href="https://www.youtube.com" title="YouTube" className="social-btn" target="_blank" rel="noreferrer">▶</a>
              <a href={whatsappHref} title="WhatsApp" className="social-btn" target="_blank" rel="noreferrer">💬</a>
            </div>
          </div>

          {/* NEWSLETTER */}
          <div className="footer-newsletter">
            <h4>Stay Updated</h4>
            <p>Get exclusive offers and food updates</p>
            <form onSubmit={handleSubscribe} className="newsletter-form">
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit">Subscribe</button>
            </form>
            {subscribed && <p className="success-msg">✓ Thank you for subscribing!</p>}
            <div style={{ marginTop: "10px" }}>
              <a
                className="secondary-action inline-link"
                href={whatsappHref}
                target="_blank"
                rel="noreferrer"
              >
                Subscribe on WhatsApp
              </a>
            </div>
          </div>
        </div>

        {/* MIDDLE SECTION - LINKS GRID */}
        <div className="footer-middle">
          <div className="footer-grid">
            
            {/* COMPANY LINKS */}
            <div className="footer-column">
              <h4>Company</h4>
              <div className="links-list">
                {links.company.map((link, idx) => (
                  <button
                    key={idx}
                    onClick={() => link.path !== "#" && navigate(link.path)}
                    className="footer-link"
                  >
                    {link.label}
                  </button>
                ))}
              </div>
            </div>

            {/* SUPPORT LINKS */}
            <div className="footer-column">
              <h4>Support</h4>
              <div className="links-list">
                {links.support.map((link, idx) => (
                  <button
                    key={idx}
                    onClick={() => link.path !== "#" && navigate(link.path)}
                    className="footer-link"
                  >
                    {link.label}
                  </button>
                ))}
              </div>
            </div>

            {/* LEGAL LINKS */}
            <div className="footer-column">
              <h4>Legal</h4>
              <div className="links-list">
                {links.legal.map((link, idx) => (
                  <button
                    key={idx}
                    onClick={() => link.path !== "#" && navigate(link.path)}
                    className="footer-link"
                  >
                    {link.label}
                  </button>
                ))}
              </div>
            </div>

            {/* SERVICE AREAS */}
            <div className="footer-column">
              <h4>Delivery Areas</h4>
              <div className="service-areas">
                <div className="area-item">📍 Malad</div>
                <div className="area-item">📍 Kandivali</div>
                <div className="area-item">📍 Borivali</div>
                <div className="area-item">📍 Dahisar</div>
              </div>
            </div>
          </div>
        </div>

        {/* INFO SECTION */}
        <div className="footer-info">
          <div className="info-card">
            <span className="info-icon">⚡</span>
            <div>
              <strong>Delivery</strong>
              <p>Fast and reliable delivery</p>
            </div>
          </div>
          <div className="info-card">
            <span className="info-icon">👨‍🍳</span>
            <div>
              <strong>Fresh Food</strong>
              <p>Prepared fresh to order</p>
            </div>
          </div>
          <div className="info-card">
            <span className="info-icon">🛡️</span>
            <div>
              <strong>Secure Payment</strong>
              <p>Multiple payment options</p>
            </div>
          </div>
          <div className="info-card">
            <span className="info-icon">24/7</span>
            <div>
              <strong>24/7 Support</strong>
              <p>Always here to help</p>
            </div>
          </div>
        </div>

        {/* App download section removed per request */}
      </div>

      {/* BOTTOM SECTION */}
      <div className="footer-bottom">
        <div className="bottom-content">
          <div className="copyright">
            © 2026 Shreeji Surti Swad. All rights reserved.
          </div>
          <div className="payment-methods">
            <span>Payments: </span>
            <span className="payment-icon">💳</span>
            <span className="payment-icon">📱</span>
            <span className="payment-icon">🏦</span>
          </div>
        </div>
      </div>
    </footer>
  );
}